var _path, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgInstructionsStudioTab = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V28C0 30.2091 1.79086 32 4 32H28C30.2091 32 32 30.2091 32 28V4C32 1.79086 30.2091 0 28 0H4ZM6.33333 8C5.78105 8 5.33333 8.44772 5.33333 9V9.66667C5.33333 10.219 5.78105 10.6667 6.33333 10.6667H25.6667C26.219 10.6667 26.6667 10.219 26.6667 9.66667V9C26.6667 8.44771 26.219 8 25.6667 8H6.33333ZM6.33333 14.6667C5.78105 14.6667 5.33333 15.1144 5.33333 15.6667V16.3333C5.33333 16.8856 5.78105 17.3333 6.33333 17.3333H25.6667C26.219 17.3333 26.6667 16.8856 26.6667 16.3333V15.6667C26.6667 15.1144 26.219 14.6667 25.6667 14.6667H6.33333ZM5.33333 22.3333C5.33333 21.781 5.78105 21.3333 6.33333 21.3333H20.3333C20.8856 21.3333 21.3333 21.781 21.3333 22.3333V23C21.3333 23.5523 20.8856 24 20.3333 24H6.33333C5.78105 24 5.33333 23.5523 5.33333 23V22.3333Z",
    fill: "var(--asset-gradient-id)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "overview-gradient-top",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--asset-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--asset-bg-color)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "overview-gradient-left",
    x1: 32,
    y1: 32,
    x2: 0,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--asset-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--asset-bg-color)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInstructionsStudioTab, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/instructions-studio-tab.3d0dbbbd.svg";
export { ForwardRef as ReactComponent };